// NOTA: Solo se migra version 6 de Material los componentes
import React from 'react'
import { Typography, Tooltip, Box, styled } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { tooltipClasses } from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const StyledTooltip = styled(Tooltip)({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '14px',
    maxWidth: 300
  }
})

const TooltipItem = ({
  title,
  label
}: {
  title: React.ReactNode
  label: string
}) => (
  <Grid size={{ xs: 12, sm: 6, md: 2 }}>
    <StyledTooltip title={title} arrow placement='top'>
      <Box display='flex' alignItems='center' style={{ cursor: 'pointer' }}>
        <InfoOutlinedIcon
          fontSize='medium'
          style={{ marginRight: '8px', color: '#FF9800' }}
        />
        <Typography variant='body1' component='span'>
          {label}
        </Typography>
      </Box>
    </StyledTooltip>
  </Grid>
)

export const StepReturnQualityFooterInfo: React.FC = () => {
  return (
    <Grid container spacing={0} size={12}>
      <Grid size={{ md: 2 }} />

      <TooltipItem
        label='En Perfecto estado'
        title={
          <span>
            Producto apto para venta.
            <br />
            Se debe continuar el proceso desde Put Away para finalizar la
            devolución.
          </span>
        }
      />

      <TooltipItem
        label='Rechazo comercial'
        title={
          <span>
            Producto con observación.
            <br />
            Diríjase al módulo de Alertas de Inventario.
          </span>
        }
      />

      <TooltipItem
        label='Enviar a calidad'
        title={
          <span>
            Producto con observación.
            <br />
            Diríjase al módulo de Alertas de Inventario.
          </span>
        }
      />

      <TooltipItem
        label='Faltante'
        title={
          <span>
            Producto no encontrado.
            <br />
            Se enviarán a ubicación de diferencia.
          </span>
        }
      />

      <Grid size={{ md: 2 }} />
    </Grid>
  )
}
